/**
 * T22.521: an Image-with-text block whose image was never set saves `image: {}`.
 * The builder shows the "upload image" placeholder in that slot so the author
 * can click it, but the published wheel (craftjs <Editor enabled={false}>)
 * showed the same placeholder to visitors, so it looked like a broken image.
 * The slot shows only when there is an image, an upload is running, or the
 * block is being edited.
 */
export const shouldShowImageSlot = ({ imageSrc, editorEnabled, isUploading }) =>
  Boolean(imageSrc) || Boolean(isUploading) || editorEnabled !== false;
